import React from "react";
// import { AuthContext } from "../context/AuthContext";

import "../styles/SettingsView.scss";

export const SettingsView = () => {
  // const { apiInstance } = React.useContext(AuthContext);
  return <p>Settings</p>;
};
